<template>

    <div class="container section">
        <div class="row heading">
            <div class="col">
                <h2>Load Serviceability File</h2>
            </div>
        </div>

        <div class="upload-form">
            <vue-clip :options="options" class="" :on-added-file="fileAdded" :on-sending="sending" :on-complete="complete">
                <template slot="clip-uploader-body" scope="props">
                    <div class="row lined upload-preview" v-for="file, i in props.files" v-show="file.progress < 100 && file.status != 'success'">
                        <div class="col">
                            <div class="media">
                                <div class="media-body">
                                    <a @click="props.files.splice(i, 1)" class="link-padding float-right" v-if="file.status == 'error'"><i class="fa fa-remove text-danger"></i></a>
                                    <h5 class="mt-2">
                                        {{file.name}}
                                        <div v-show="file.progress == 100 && file.status != 'added'" class="file-status" :class="{'text-danger': isError(file.status), 'text-success': isSuccess(file.status) }">{{file.status}}</div></h5>
                                    <div class="file-progress" v-show="file.progress < 100 ">
                                        <span class="progress-indicator" :class="{error: isError(file.status) }" v-bind:style="{width:file.progress + '%'}"></span>
                                    </div>
                                    <div class="text-danger link-padding" v-show="file.errorMessage">{{file.errorMessage}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template class="upload-btn" slot="clip-uploader-action" scope="props">
                    <button class="btn btn-primary dz-message" href="#"><i class="fa fa-plus"></i> &nbsp;Add File(s)</button>
                </template>
            </vue-clip>
        </div>
    </div>
</template>


<script type="text/babel">

    export default {
        name: 'CarrierServiceableLoader',
        data: function(){
            return {
                params: {
                    data: {
                        account_id: ''
                    }
                },
                options:{
                    url: '',
                    headers: {

                    }
                },
                accountFiles:[],
                files:[],
                uploading: false

            }
        },
        components:{

        },
        created(){
            this.options.url = this.$endpoint;
            this.params.data.account_id = this.$route.params.account_id;
        },
        computed:{

        },
        filters:{

        },
        methods:{
            fileNotYetLoaded(file){
                return file.progress < 100 && file.status != 'success';
            },
            complete(file){
                alert('File Uploaded');
            },
            isError(status){
                return status == "error";
            },
            isSuccess(status){
                return status == "success";
            },
            fileAdded(){
                this.uploading = true;
            },
            sending (file, xhr, formData) {
                formData.append('function', 'carrierServiceableLoad');
                formData.append("token", this.$store.getters.getToken);
            },
        }

    }

</script>


// WEBPACK FOOTER //
// CarrierServiceableLoad.vue?5a89208a